import React, { FC, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import Restaurant from 'types/restaurant';
import pictogramCelebrate from 'images/pictograms/picto-celebrate-lg.svg';
import { ONB_WIZARD_INTRO, ONE_DASHBOARD_BASE_URL } from 'helpers/constants';
import { CompanyContext } from 'context/CompanyContext';

import PageIntro from '../PageIntro';
import OnboardingContainer from '../OnboardingContainer';
import {
  CardWrapper,
  StyledButton,
} from './styles';

interface CompletedContentProps {
  restaurant: Restaurant;
}

const CompletedContent: FC<CompletedContentProps> = ({ restaurant }) => {
  const { company } = useContext(CompanyContext);
  const navigate = useNavigate();

  const handleExploreClick = () => {
    if (company?.should_redirect_to_portal) {
      window.open(ONE_DASHBOARD_BASE_URL, '_blank');
    } else {
      navigate(`/restaurant/${restaurant?.id}`);
    }
  };

  return (
    <OnboardingContainer>
      <CardWrapper>
        <PageIntro
          pictogram={pictogramCelebrate}
          pictogramLabel="Logo and Food Image"
          title={ONB_WIZARD_INTRO.completedTitle}
          description={ONB_WIZARD_INTRO.completedDesc}
        />
        <StyledButton
          label="Start Exploring"
          onClick={handleExploreClick}
        />
      </CardWrapper>
    </OnboardingContainer>
  );
};

export default CompletedContent;
